import create from 'zustand';
import { devtools } from 'zustand/middleware';

interface UseOldParamsInterface {
    value: string | null,
    setOldParams: (oldParams : string | null) => void
}

export const useOldParams = create<UseOldParamsInterface>()(devtools(set => ({
    value: null,
    setOldParams: (oldParams) => {
        set(() => ({ value : oldParams }))
    },
})));
